import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ServiceBillingService } from '../../service-billing/service-billing.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-service-billing-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './service-billing-details.component.html',
  styleUrls: ['./service-billing-details.component.scss'],
})
export class ServiceBillingDetailsComponent implements OnInit {
  billing: any;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceBillingService: ServiceBillingService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    const billingId = this.route.snapshot.paramMap.get('id');
    if (billingId) {
      this.loadBillingDetails(billingId);
    } else {
      this.toastr.error('Service Billing ID not found in the URL.', 'Error');
    }
  }

  loadBillingDetails(id: string) {
    this.isLoading = true;
    this.serviceBillingService.getServiceInvoiceById(id).subscribe({
      next: (data: any) => {
        this.billing = data;
        this.isLoading = false;
        console.log('Fetched service billing details:', this.billing);
      },
      error: (err: any) => {
        this.toastr.error('Failed to fetch service billing details.', 'Error');
        this.isLoading = false;
        console.error('Error fetching service billing details', err);
        this.billing = null;
      },
    });
  }

  formatCurrency(value: string | number): string {
    const num =
      typeof value === 'string' ? parseFloat(value || '0') : value || 0;
    return `₹${num.toFixed(2)}`;
  }

  goBack() {
    this.router.navigate(['/reports']); // Assuming it goes back to reports summary
  }
}
